import React, { useState, useMemo, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import swal from 'sweetalert';
import { Modal, ModalFooter } from 'react-bootstrap';
import Sidebar_Progress, { prevNonNumericalWithDec } from '../layouts/Operational_Sidebar_Progress.component';
import ManagerLoginHeader from '../operational-model/Manager/ManagerLoginHeader.component';
import Loader from '../operational-model/Employee/Loader.component';
import customer_review from '../../img/customer-review.png';
import museum from '../../img/museum.svg';
import { API_URL } from '../../constant/API_Settings';
import { getStoredPermissions } from '../../utils/permissions';
import OperationalListFilterBar from '../operational-model/shared/OperationalListFilterBar';
import {
  DEFAULT_OPERATIONAL_LIST_FILTERS,
  appendOperationalListFilters,
  validateOperationalDateRange,
} from '../../utils/operationalListFilters';
import {
  isPriceChangeEnabled,
  normalizeOptionalCylinderPrice,
  validateVendorFullPriceChangeSplit,
} from '../../utils/gasCylinderPurchasePrice';

/** from: 0 = vendor, 1 = customer (cylinder_purchase.from). type: 0 full, 1 exchange, 2 empty. */
const isPurchaseFromVendor = (row) => Number(row?.from) === 0;

const purchasePartyColumnLabel = (row) => (isPurchaseFromVendor(row) ? 'Vendor' : 'Customer');

const purchasePartyName = (row) => {
  if (isPurchaseFromVendor(row)) {
    return row?.name ?? '--';
  }

  return row?.cust_name ?? '--';
};

const purchaseKindLabel = (type) => {
  const purchaseType = Number(type);
  if (purchaseType === 0) {
    return 'Full Cylinder';
  }
  if (purchaseType === 1) {
    return 'Empty to Full Cylinder Exchange';
  }
  if (purchaseType === 2) {
    return 'Empty Cylinder';
  }

  return '--';
};

const normalizeProductForSave = (product) => {
  const prepared = { ...product };
  if (isPriceChangeEnabled(prepared.price_change) && prepared.new_price) {
    prepared.pp_inc_gst_aft_disc = prepared.new_price;
    const qty = parseFloat(prepared.quantity) || 0;
    const unit = parseFloat(prepared.new_price) || 0;
    prepared.total_pp_inc_gst_aft_disc = Number((qty * unit).toFixed(2));
  }
  // Unknown empty-cylinder price is stored as 0; do not invent a shell price.
  prepared.price_change_empty = normalizeOptionalCylinderPrice(prepared.price_change_empty);
  return prepared;
};

const formatCylinderPurchaseResponseMessage = (responseData) => {
  if (!responseData) {
    return 'Unexpected response from server.';
  }

  if (typeof responseData.message === 'string' && responseData.message.trim()) {
    return responseData.message;
  }

  if (responseData.message && typeof responseData.message === 'object') {
    const values = Object.values(responseData.message).filter(Boolean);
    if (values.length) {
      return values.join('\n');
    }
  }

  if (responseData.response && typeof responseData.response === 'object') {
    const values = [];
    Object.values(responseData.response).forEach((entry) => {
      if (Array.isArray(entry)) {
        values.push(...entry.filter(Boolean));
      } else if (entry) {
        values.push(String(entry));
      }
    });
    if (values.length) {
      return values.join('\n');
    }
  }

  return 'Unable to save purchase. Please check the form and try again.';
};

const isCylinderPurchaseSaveSuccessful = (status) =>
  status === true || status === 1 || status === '1' || status === 'true';

const GasCylinderPurchaseConfig = (props) => {
  const location = useLocation();
  const [day_closing_date, setDayclosedate] = useState({ date: location?.state || "" });
  const [searchFilters, setSearchFilters] = useState({ ...DEFAULT_OPERATIONAL_LIST_FILTERS });
  const [Loading, setLoading] = useState(false);
  const [listGas, setListGas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [inputValues, setInputValues] = useState([]);
  let permissions = getStoredPermissions();
  const [permission, setPermission] = useState([]);

  const handleChange = (e) => {
    // Add robust null checks
    if (!e || !e.target || !e.target.name) {
      console.warn("Invalid event object in handleChange", e);
      return;
    }

    const { name, value } = e.target;

    setInputValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [name]: value,
      };

      if (name === "vendor_id") {
        const row = vendor_data?.find((d) => String(d[0]) === String(value));
        if (row?.[2] === "nf_stock_up") {
          newValues.invoice_number = "";
          if (newValues.type === "1") {
            newValues.type = "0";
          }
        } else if (row && prevValues.fromValue === "0" && newValues.type === "2") {
          // Empty Cylinder is only valid for nf_stock_up; revert when vendor changes.
          newValues.type = "0";
        }
      }
      
      console.log(newValues,"mmm");
      
      if (name === "type") {
        // Reset the state only when 'type' field changes
        setFieldGroups([{
          product_id: '',
          quantity: '',
          pp_inc_gst_aft_disc: '',
          price_change: '',
          new_price: '',
          price_change_empty: 0,
          price_change_gas: 0,
          total_pp_inc_gst_aft_disc: '',
          gst: '',
          pp_per_piece_exc_gst: '',
          gstamount: '',
          cgst: '',
          sgst: '',
          mrp: '',
          gst_return: '',
        }]);
      }

      if (newValues.fromValue === '0') {
        getVendor();
      }
      if (newValues.fromValue === "1") {
        getCustomer();
      }
      if (newValues.purchase_type === "2") {
        getPayments();
      }
      if (newValues.purchase_type === "3") {
        getbank();
      }

      return newValues;
    });
  };


useEffect(() => {
    gaspurchase_list();
 }, [''])

const UseModal = () =>{
    
    const [isShowing,setIsShowing] =  useState(false);
    // const [isviewShowing,setisviewShowing] =  useState(false);
    function toggle() {
      gaspurchase_list();
      setIsShowing(!isShowing)
      // setisviewShowing(!isviewShowing)
      setInputValues('');
      getProducts();
      seterrors('');
      settotal('');
      setFieldGroups([{
        product_id: '',
        quantity: '',
        pp_inc_gst_aft_disc: '',
        price_change: '',
        new_price: '',
        price_change_empty: 0,
        price_change_gas: 0,
        total_pp_inc_gst_aft_disc: '',
        gst: '',
        pp_per_piece_exc_gst: '',
        gstamount: '',
        cgst: '',
        sgst: '',
        mrp: '',
        gst_return: '',
      }]);
   
    }
    return {
        isShowing,
        // isviewShowing,
        toggle,
      }
  
  }
const { isShowing, toggle } = UseModal();
// const { isviewShowing, toggle } = UseModal();
const [isviewShowing,setisviewShowing] =  useState(false);
const [vendor_data, setVendor] = useState([])
const selectedVendorAcName = useMemo(() => {
  return vendor_data?.find((d) => String(d[0]) === String(inputValues.vendor_id))?.[2];
}, [vendor_data, inputValues.vendor_id]);
const isNfStockUpVendor =
  inputValues.fromValue === "0" && selectedVendorAcName === "nf_stock_up";
const [customer_data, setCustomer] = useState([])
const [productsdropdown,Setproductsdropdown] = useState([]);
const [dropdownDatas, setDropdownDatas] = useState([])
const [banks, setBanks] = useState([]);
const [total, settotal] = useState([]);
const [productprice, setproductprice] = useState([]);
const [list_gas, setListgas] = useState([]);
const [list_view, setListview] = useState([]);
const [fieldGroups, setFieldGroups] = useState([{ product_id: '',
                                                  quantity:'',
                                                  pp_inc_gst_aft_disc:'',
                                                  price_change:'',
                                                  new_price:'',
                                                  price_change_empty:0,
                                                  price_change_gas:0,
                                                  total_pp_inc_gst_aft_disc:'',
                                                  gst:'',
                                                  pp_per_piece_exc_gst:'',
                                                  gstamount:'',
                                                  cgst:'',
                                                  sgst:'',
                                                  mrp:'',
                                                  gst_return:'',
                                                }]);
                                                console.log(fieldGroups,"fieldGroupsfieldGroupsfieldGroups")
                                                
const [errors,seterrors] =useState({fromValue:"",
                                    vendor_id:"",
                                    customer_id:"",
                                    type:"",
                                    invoice_number:"",
                                    product_id:"",
                                    quantity:"",
                                    pp_inc_gst_aft_disc:"",
                                    total_pp_inc_gst_aft_disc:"",
                                    gst:"",
                                    pp_per_piece_exc_gst:"",
                                    gstamount:"",
                                    mrp:"",
                                    purchase_type:"",
                                    Digital_Type:"",
                                    bank:"",                                
});



const viewproduct = (id) => {
  gaspurchase_view(id)
  setisviewShowing(true)
}
const viewproductclose = (id) => {
  setisviewShowing(false)
  
}

function validation(){
    let errors=[];
    let formIsValid = true
    if ((!inputValues.fromValue)) {
         
        formIsValid = false;
        errors["fromValue"] = "Sales Form Type"
    } else {
        errors["fromValue"] = ""
    }

    const skipInvoice =
      inputValues.fromValue === "0" &&
      vendor_data?.find((d) => String(d[0]) === String(inputValues.vendor_id))?.[2] === "nf_stock_up";
    if (!skipInvoice && !inputValues.invoice_number) {
      formIsValid = false;
      errors["invoice_number"] = "Invoice Number Is needed";
    } else {
      errors["invoice_number"] = "";
    }

    if (inputValues.fromValue == 0) {
        if (!inputValues.vendor_id) {
          formIsValid = false;
          errors["vendor_id"] = "Select Vendor";
        }
      } else if (inputValues.fromValue == 1) {
        if (!inputValues.customer_id) {
          formIsValid = false;
          errors["customer_id"] = "Select Customer";
        }
      }

      if (inputValues.purchase_type === "Select" || 
      !["0", "1", "2", "3"].includes(inputValues.purchase_type)) {
      formIsValid = false;
      errors["purchase_type"] = "Select Transaction Method";
  } else {
      errors["purchase_type"] = "";
  }

  

  if (inputValues.purchase_type == 2) {
    if (!inputValues.Digital_Type) {
        formIsValid = false;
        errors["Digital_Type"] = "Select Digital Payment";
    } else {
        errors["Digital_Type"] = "";
    }
  } else if (inputValues.purchase_type == 3) {
    if (!inputValues.bank) {
      formIsValid = false;
      errors["bank"] = "Select Bank";
    }
  }
    if (!Array.isArray(fieldGroups) || fieldGroups.length === 0) {
        formIsValid = false;
        errors["product_id"] = "At least one product is required";
    } else {
        errors["product_id"] = "";
        fieldGroups.forEach((product, index) => {
            console.log(product,"pppppppppppp")
            if (!product.product_id) {
               
                formIsValid = false;
                errors[`product_${index}_id`] = "Select Product";
                errors[`price_change${index}_id`] = "";
            } else {
                errors[`product_${index}_id`] = "";
                if (product.price_change !== "0" && product.price_change !== "1" && product.price_change !== 0 && product.price_change !== 1) {
                    formIsValid = false;
                    errors[`price_change${index}_id`] = "Please select Yes or No";
                } else {
                    errors[`price_change${index}_id`] = "";
                }
            }
            if (!product.quantity) {
                formIsValid = false;
                errors[`quantity${index}_id`] = "Enter Quantity";
            } else {
                errors[`quantity${index}_id`] = "";
            }
            // if (!product.pp_inc_gst_aft_disc) {
            //     formIsValid = false;
            //     errors[`pp_inc_gst_aft_disc${index}_id`] = "Enter Purchase Price";
            // } else {
            //     errors[`pp_inc_gst_aft_disc${index}_id`] = "";
            // }
            if (inputValues.fromValue !== '1' && !product.gst) {
                formIsValid = false;
                errors[`gst${index}_id`] = "Please Enter Gst%";
            } else {
                errors[`gst${index}_id`] = "";
            }
            if (!product.mrp) {
                formIsValid = false;
                errors[`mrp${index}_id`] = "Please Enter Mrp ";
            } else {
                errors[`mrp${index}_id`] = "";
            }
            if (isPriceChangeEnabled(product.price_change) && !product.new_price) {
                formIsValid = false;
                errors[`new_price${index}_id`] = "Please enter new purchase price";
            } else {
                errors[`new_price${index}_id`] = "";
            }
            const splitErrors = validateVendorFullPriceChangeSplit(product, {
              fromVendor: inputValues.fromValue == 0,
              purchaseType: inputValues.type,
            });
            errors[`price_change_empty${index}_id`] = splitErrors.price_change_empty;
            if (splitErrors.price_change_gas) {
                formIsValid = false;
                errors[`price_change_gas${index}_id`] = splitErrors.price_change_gas;
            } else {
                errors[`price_change_gas${index}_id`] = "";
            }
            if (splitErrors.price_sum_mismatch) {
                formIsValid = false;
                errors[`price_sum_mismatch${index}_id`] = splitErrors.price_sum_mismatch;
            } else {
                errors[`price_sum_mismatch${index}_id`] = "";
            }

            // if (product.price_change == 1 && product.new_price && product.price_change_empty && product.price_change_gas) {
            //     const emptyPrice = parseFloat(product.price_change_empty);
            //     const gasPrice = parseFloat(product.price_change_gas);
            //     const newPrice = parseFloat(product.new_price);
                
            //     if (isNaN(emptyPrice) || isNaN(gasPrice)) {
            //         formIsValid = false;
            //         errors[`price_sum_mismatch${index}_id`] = "Empty price and Gas price must be valid numbers.";
            //     } else if (emptyPrice + gasPrice !== newPrice) {
            //         formIsValid = false;
            //         errors[`price_sum_mismatch${index}_id`] = "The sum of empty price and Gas price must be equal to the new price.";
            //     } else {
            //         errors[`price_sum_mismatch${index}_id`] = "";
            //     }
            // } else {
            //     // Handle the case where `product.price_change`, `product.new_price`, `product.price_change_empty`, or `product.price_change_gas` is missing
            //     if (product.price_change == 1 || product.new_price || !product.price_change_empty || !product.price_change_gas) {
            //         formIsValid = false;
            //         errors[`price_sum_mismatch${index}_id`] = "Empty and Gas price fields must be filled and equal to New Price.";
            //     }

            // }
            
       
    
            
        });
    }
  
    // alert(formIsValid)
    seterrors(errors)
    return formIsValid;

}

  const handleAdd = () => {
    setFieldGroups([...fieldGroups, { name: '',product_id: '',
    quantity:'',
    pp_inc_gst_aft_disc:'',
    price_change:'',
    new_price:'',
    price_change_empty:'',
    price_change_gas:'',
    total_pp_inc_gst_aft_disc:'',
    gst:'',
    pp_per_piece_exc_gst:'',
    gstamount:'',
    cgst:'',
    sgst:'',
    mrp:'',
    gst_return:'', }]);
  };

  const handleRemove = (index) => {
    const updatedFieldGroups = [...fieldGroups];
    updatedFieldGroups.splice(index, 1);
    setFieldGroups(updatedFieldGroups);
  };

  const handleChanges = (index, event) => {
    const updatedFieldGroups = [...fieldGroups];
    updatedFieldGroups[index][event.target.name] = event.target.value;
    setFieldGroups(updatedFieldGroups);
    if (updatedFieldGroups[index]["product_id"]) {
        gasprice(updatedFieldGroups);
    }
    console.log(updatedFieldGroups,"inputs1")
  };
  console.log(inputValues,"inputs")

  function getVendor() {
    const requestOptions = {
        method: 'get',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json"
        },
    };
    fetch(API_URL + "/get_vendors", requestOptions)
        .then(response => { return response.json(); })
        .then(responseData => {
            var datas = []

            responseData.forEach(elem => {
                datas.push([elem.id, elem.name, elem.ac_name])
            })

            setVendor(datas);
            return responseData;
        })
        .catch(e => {
            console.log(e);

        });
}

function getCustomer() {
    const requestOptions = {
        method: 'get',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json"

        },
    };
    fetch(API_URL + "/get_customers", requestOptions)
        .then(response => { return response.json(); })
        .then(responseData => {
            var datas = []

            responseData.forEach(elem => {
                datas.push([elem.id, elem.name])
            })

            setCustomer(datas);

            return responseData;
        })
        .catch(e => {
            console.log(e);

        });
}

function getbank() {
    const requestOptions = {
        method: 'get',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json"

        },
    };
    fetch(API_URL + "/bank_dd", requestOptions)
        .then(response => { return response.json(); })
        .then(responseData => {
            var datas = []

            responseData.forEach(elem => {
                datas.push([elem.id, elem.method_name])
            })

            setBanks(datas);

            return responseData;
        })
        .catch(e => {
            console.log(e);

        });
}
function getProducts() {
    const requestOptions = {
        method: 'get',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json"

        },
    };
    fetch(API_URL + "/gas_products", requestOptions)
        .then(response => { return response.json(); })
        .then(responseData => {
            var PRODUCTdatas = []

            responseData.data.forEach(elem1 => {
                PRODUCTdatas.push([elem1.id, elem1.product_name])
            })

            Setproductsdropdown(PRODUCTdatas);
           
           

            return responseData;
        })
        .catch(e => {
            console.log(e);

        });
}

function getPayments() {
    const requestOptions = {
        method: 'get',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json"
        },
    };
    fetch(API_URL + "/get_digital_payment", requestOptions)
        .then(response => { return response.json(); })
        .then(responseData => {
            var datas = []
            
            
            let newData = [];
             newData = responseData.map(elem => ({
                value: elem.id,
                label: elem.method_name,
            }));

            setDropdownDatas(dropdownDatas => [
                ...newData
            ]);

        })
        .catch(e => {
            console.log(e);

        });
}

// function gasprice() {
//     let products = fieldGroups; 
//     let type = inputValues.type;
  
//     products.forEach((product, index) => {
//         const product_id = product.product_id;
        
//         const requestOptions = {
//             method: 'POST',
//             headers: {
//                 "Access-Control-Allow-Origin": "*",
//                 "Content-Type": "application/json",
//                 "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
//                 "Accept": "application/json"
//             },
//             body: JSON.stringify({
//                 id: product_id,
//                 sales_type: type,
//                 index: index,
//             })
//         };

//         fetch(API_URL + "/gas_pp", requestOptions)
//             .then(response => response.json())
//             .then(responseData => {
//                 console.log(responseData.data.purchase_price_full,"ggggggg")
//                 if (responseData.status === true) {
                    
//                     if (type == 0 && product_id) {
                       
//                         setFieldGroups(prevFieldGroups => {
                            
//                             const updatedFieldGroups = [...prevFieldGroups];
//                             updatedFieldGroups[index]['pp_inc_gst_aft_disc'] = responseData?.data?.purchase_price_full;
                            
                           
//                             // setFieldGroups(updatedFieldGroups);
//                             return updatedFieldGroups;
//                         });
//                     }
//                     if (type == 1 && product_id) {
                       
//                         setFieldGroups(prevFieldGroups => {
                            
//                             const updatedFieldGroups = [...prevFieldGroups];
//                             updatedFieldGroups[index]['pp_inc_gst_aft_disc'] = responseData?.data?.purchase_price_exchange;
                            
                           
//                             // setFieldGroups(updatedFieldGroups);
//                             return updatedFieldGroups;
//                         });
//                     }
//                     if (type == 2 && product_id) {
                       
//                         setFieldGroups(prevFieldGroups => {
                            
//                             const updatedFieldGroups = [...prevFieldGroups];
//                             updatedFieldGroups[index]['pp_inc_gst_aft_disc'] = responseData?.data?.purchase_price_empty;
                            
                           
//                             // setFieldGroups(updatedFieldGroups);
//                             return updatedFieldGroups;
//                         });
//                     }
//                     setFieldGroups(prevFieldGroups => {
                        
//                         const updatedFieldGroups = [...prevFieldGroups];
//                         let nettotal = 0;
//                         updatedFieldGroups[index]['total_pp_inc_gst_aft_disc'] = updatedFieldGroups[index]['quantity'] * updatedFieldGroups[index]['pp_inc_gst_aft_disc'];
//                         updatedFieldGroups[index]['pp_per_piece_exc_gst'] = 
//                         Number((updatedFieldGroups[index]['pp_inc_gst_aft_disc'] / (1 + (updatedFieldGroups[index]['gst'] / 100))).toFixed(2));
//                         updatedFieldGroups[index]['gstamount'] =  Number((updatedFieldGroups[index]['pp_per_piece_exc_gst']) * ((updatedFieldGroups[index]['gst'])/100)).toFixed(2)
//                         updatedFieldGroups[index]['cgst'] = (updatedFieldGroups[index]['gstamount'] / 2).toFixed(2);
//                         updatedFieldGroups[index]['sgst']=(updatedFieldGroups[index]['gstamount']/2).toFixed(2);
                       
//                        let returnGst = ((updatedFieldGroups[index]['mrp'] * (100 / (100 + updatedFieldGroups[index]['gst']))).toFixed(2)) - (updatedFieldGroups[index]['pp_per_piece_exc_gst']).toFixed(2);
//                        returnGst = parseFloat(returnGst);
//                        updatedFieldGroups[index]['gst_return'] = (returnGst * (updatedFieldGroups[index]['gst'] / 100)).toFixed(2);

                       
//                     //    const updatedNetTotal = nettotal + updatedFieldGroups[index]['quantity'] * updatedFieldGroups[index]['pp_inc_gst_aft_disc'];
//                     //    settotal(updatedNetTotal);

//                     const quantity = parseFloat(updatedFieldGroups[index]['quantity']) || 0;
//                     const ppIncGstAftDisc = parseFloat(updatedFieldGroups[index]['pp_inc_gst_aft_disc']) || 0;
//                     const updatedNetTotal = nettotal + quantity * ppIncGstAftDisc;
//                      settotal(updatedNetTotal);
//                         console.log(nettotal,"nettotal")

//                         return updatedFieldGroups;
//                     });
                    
                    
//                 } 
//                 // else {
//                 //     console.error('Error in response data:', responseData.message);
//                 // }
//             })
//             .catch(e => {
//                 // console.error('Fetch error:', e);
//             });
//     });
// }



function gasprice(groupsOverride) {
    const products = groupsOverride ?? fieldGroups;
    const type = inputValues.type;
    const isCustomerEmptyReturn = inputValues.fromValue === '1' && type === '2';

    // Create an array of promises for each fetch call
    const fetchPromises = products.map((product, index) => {
        const product_id = product.product_id;

        const requestOptions = {
            method: 'POST',
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: product_id,
                sales_type: type,
                index: index,
            })
        };

        return fetch(API_URL + "/gas_pp", requestOptions)
            .then(response => response.json())
            .then(responseData => {
                if (responseData.status === true) {
                    const updatedFieldGroups = [...products];
                    let purchasePrice;

                    if (type == 0) {
                        purchasePrice = responseData?.data?.purchase_price_full;
                    } else if (type == 1) {
                        purchasePrice = responseData?.data?.purchase_price_exchange;
                    } else if (type == 2) {
                        purchasePrice = responseData?.data?.purchase_price_empty;
                    }

                    if (isPriceChangeEnabled(updatedFieldGroups[index]['price_change'])) {
                        const newPrice = parseFloat(updatedFieldGroups[index]['new_price']);
                        if (product_id && !Number.isNaN(newPrice)) {
                            updatedFieldGroups[index]['pp_inc_gst_aft_disc'] = updatedFieldGroups[index]['new_price'];
                            updatedFieldGroups[index]['total_pp_inc_gst_aft_disc'] = Number((updatedFieldGroups[index]['quantity'] * newPrice).toFixed(2));

                            if (isCustomerEmptyReturn) {
                                updatedFieldGroups[index]['pp_per_piece_exc_gst'] = Number(newPrice);
                                updatedFieldGroups[index]['gstamount'] = 0;
                            } else {
                                const gstRate = parseFloat(updatedFieldGroups[index]['gst']) || 0;
                                updatedFieldGroups[index]['pp_per_piece_exc_gst'] = Number((newPrice / (1 + (gstRate / 100))).toFixed(2));
                                updatedFieldGroups[index]['gstamount'] = Number((updatedFieldGroups[index]['pp_per_piece_exc_gst'] * (gstRate / 100)).toFixed(2));
                            }

                            updatedFieldGroups[index]['cgst'] = Number((updatedFieldGroups[index]['gstamount'] / 2).toFixed(2));
                            updatedFieldGroups[index]['sgst'] = Number((updatedFieldGroups[index]['gstamount'] / 2).toFixed(2));

                            const returngst1 = Number(updatedFieldGroups[index]['mrp']) * (100 / (100 + (Number(updatedFieldGroups[index]['gst']) || 0)));
                            const returngst2 = newPrice * (100 / (100 + (Number(updatedFieldGroups[index]['gst']) || 0)));
                            const returngst3 = returngst1 - returngst2;
                            updatedFieldGroups[index]['gst_return'] = parseFloat((returngst3 * ((Number(updatedFieldGroups[index]['gst']) || 0) / 100)).toFixed(2));
                        }

                        return {
                            index,
                            updatedFieldGroups,
                            netTotal: Number((updatedFieldGroups[index]['quantity'] * (parseFloat(updatedFieldGroups[index]['new_price']) || 0)).toFixed(2))
                        };

                    } else if (product_id) {
                    
                        updatedFieldGroups[index]['pp_inc_gst_aft_disc'] = purchasePrice;
                        updatedFieldGroups[index]['total_pp_inc_gst_aft_disc'] = Number((updatedFieldGroups[index]['quantity'] * purchasePrice).toFixed(2));

                        if (isCustomerEmptyReturn) {
                            updatedFieldGroups[index]['pp_per_piece_exc_gst'] = Number(purchasePrice);
                            updatedFieldGroups[index]['gstamount'] = 0;
                            updatedFieldGroups[index]['cgst'] = 0;
                            updatedFieldGroups[index]['sgst'] = 0;
                            updatedFieldGroups[index]['gst_return'] = 0;
                        } else {
                            updatedFieldGroups[index]['pp_per_piece_exc_gst'] = Number((purchasePrice / (1 + (updatedFieldGroups[index]['gst'] / 100))).toFixed(2));
                            updatedFieldGroups[index]['gstamount'] = Number((updatedFieldGroups[index]['pp_per_piece_exc_gst'] * (updatedFieldGroups[index]['gst'] / 100)).toFixed(2));
                            updatedFieldGroups[index]['cgst'] = Number((updatedFieldGroups[index]['gstamount'] / 2).toFixed(2));
                            updatedFieldGroups[index]['sgst'] = Number((updatedFieldGroups[index]['gstamount'] / 2).toFixed(2));

                            const returngst1 =Number(updatedFieldGroups[index]['mrp'])*(100/(100+(Number(updatedFieldGroups[index]['gst']))))
                            const returngst2=Number(updatedFieldGroups[index]['pp_inc_gst_aft_disc'])*(100/(100+(Number(updatedFieldGroups[index]['gst']))))
                            const returngst3 =returngst1 -returngst2
                            updatedFieldGroups[index]['gst_return'] = parseFloat((returngst3 * (Number(updatedFieldGroups[index]['gst']) / 100)).toFixed(2));
                        }
                    }
                    
                    return {
                        index,
                        updatedFieldGroups,
                        netTotal: Number((updatedFieldGroups[index]['quantity'] * (updatedFieldGroups[index]['pp_inc_gst_aft_disc'] || updatedFieldGroups[index]['new_price'] || 0)).toFixed(2))
                    };
                    
                } else {
                    throw new Error('Response status is not true');
                }
            })
            .catch(e => {
                console.error('Fetch error:', e);
                return { index, updatedFieldGroups: products, netTotal: 0 };
            });
    });

    Promise.all(fetchPromises)
        .then(results => {
            let totalNetTotal = 0;
            const updatedFieldGroups = [...products];

            results.forEach((result) => {
                if (result?.updatedFieldGroups?.[result.index]) {
                    updatedFieldGroups[result.index] = result.updatedFieldGroups[result.index];
                }
                totalNetTotal += result?.netTotal || 0;
            });


            setFieldGroups(updatedFieldGroups);
            settotal(totalNetTotal);
        })
        .catch(error => {
            console.error('Error processing fetch results:', error);
        });
}

console.log(fieldGroups,"fieldgroup")


console.log(total,"nettotal1")

function SendGasCylinderSave() {
    const normalizedProducts = fieldGroups.map(normalizeProductForSave);
    const invoiceTotal = normalizedProducts.reduce(
        (sum, product) => sum + (parseFloat(product.total_pp_inc_gst_aft_disc) || 0),
        0
    );

    let requestBody = {
        id: inputValues.id,
        from:inputValues.fromValue,
        invoice_number: isNfStockUpVendor ? "" : inputValues.invoice_number,
        invoice_date: document.getElementById("m_op_date").value,
        invoice_amount: invoiceTotal || total,
        note: inputValues.note,
        purchase_type: inputValues.purchase_type,
        net_amount: inputValues.net_amount,
        vendor_id : inputValues.fromValue==0? inputValues.vendor_id:'',
        sales_type : inputValues.type,
        cust_id : inputValues.fromValue==1 ? inputValues.customer_id : "",
        digital_payment_id: inputValues.purchase_type == 2 ? inputValues.Digital_Type : "",
        bank_id: inputValues.purchase_type == 3 ? inputValues.bank : "",
        product: normalizedProducts
    };

    console.log('requestBody:', requestBody);

    const requestOptions = {
        method: 'POST',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
            "Accept": "application/json"
        },
        body: JSON.stringify(requestBody)
    };

    fetch(API_URL + "/cylinder_pc", requestOptions)
        .then(response => response.json())
        .then(responseData => {
            const isSuccess = isCylinderPurchaseSaveSuccessful(responseData.status);
            const messageText = formatCylinderPurchaseResponseMessage(responseData);

            if (isSuccess) {
                swal("Success", messageText, "success").then(() => {
                    gaspurchase_list();
                    toggle();
                });
                return responseData;
            }

            swal("Error", messageText, "error");
            return responseData;
        })
        .catch(e => {
            console.log(e);
            swal("Error", "Unable to save purchase. Please try again.", "error");
        });
}

function gaspurchase_list(filtersOverride) {
    const filters = filtersOverride || searchFilters;
    const requestOptions = {
        method: 'GET',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
            "Accept": "application/json"
        }
    };
    const params = new URLSearchParams();
    if (day_closing_date?.date) params.set('day_close_date', day_closing_date.date);
    appendOperationalListFilters(params, filters);
    fetch(`${API_URL}/c_purchase_list?${params.toString()}`, requestOptions)
        .then(response => response.json())
        .then(responseData => {
            setListgas(responseData.cylinder_listing);
            setLoading(true);
            return responseData;      
        })
        .catch(e => {
            console.log(e);
        });
}

const handleSearch = (event) => {
    const { name, value } = event.target;
    setSearchFilters((prev) => ({
        ...prev,
        [name || 'search_keyword']: value,
    }));
};

const submitSearchFilters = () => {
    if (!validateOperationalDateRange(searchFilters.from_date, searchFilters.to_date)) {
        return;
    }
    gaspurchase_list();
};

const clearSearchFilters = () => {
    const cleared = { ...DEFAULT_OPERATIONAL_LIST_FILTERS };
    setSearchFilters(cleared);
    gaspurchase_list(cleared);
};

function gaspurchase_view(id) {
  // alert(id);
  

  const requestOptions = {
    method: 'get',
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
      "Accept": "application/json"
    },
  };



  fetch(`${API_URL}/c_purchase_list?id=${id}`, requestOptions) 
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(responseData => {
      setListview(responseData.cylinder_listing);
    })
    .catch(error => {
      console.error("There was an error with the fetch operation:", error);
      setLoading(false); 
    });
}




console.log(list_gas,"list_gaslist_gas")

   

  

  const handleDeleteGas = async (id) => {
    swal({
      title: "Are you sure?",
      text: "This will delete the purchase entry and related transactions.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) {
        return;
      }

      try {
        const response = await axios.delete(`${API_URL}/cylinder_purchase/${id}`, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
            "Accept": "application/json",
          },
        });

        if (response.data && response.data.status) {
          swal("", response.data.message || "Deleted successfully", "success");
          gaspurchase_list();
        } else {
          swal("", response.data.message || "Unable to delete entry", "error");
        }
      } catch (error) {
        console.error('Error deleting gas purchase:', error);
        swal("Error", "Unable to delete this gas purchase entry because the stock is already used, insufficient to revert, or due to some other issues.", "error");
      }
    });
  };

  const handleSubmit = () => {
    // SendGasCylinderSave();
    if (validation()) { 
        
        swal({
          title: "Do you want to save and approve?",
          text: "This will save the gas cylinder purchase and post the related transactions.",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willApprove) => {
          if (willApprove) {
            SendGasCylinderSave();
    
          } else {
            swal("Your changes are not saved!");
          }
        });
      }
   
  }  
  
console.log(fieldGroups,"fieldGroupsfieldGroups")

  

  return (
    <>
      <div className="main-container page-wrap">
        <div className="d-md-flex">
          <Sidebar_Progress props={props} progress={29} operation={1} />
          <div className="content-area">
            <ManagerLoginHeader />
            <div className="container pb-3 tab-view">
              <div className="row mt-3 form-container">
                <div className="row mt-3">
                  {/* Uncomment and customize if needed */}
                  {/* <div className="col-md-12 mb-3 px-4 ">
                    <Link to={backPage || "/operational-date"}>
                      <a href="#" className="float-end btn btn-gray">Go Back</a>
                    </Link>
                  </div> */}
                </div>
                <div className="form-wrap">
                {Loading ? gaspurchase_list : <Loader />}
                    <div className="tab-content" id="myTabContent">
                      <div className="tab-pane fade show active" id="packedoil" role="tabpanel" aria-labelledby="packedoil-tab">
                        <div className="">
                          <div className="row mb-3">
                            <div className="col-4">
                              <img src={museum} width="25px" className="img-fluid" alt=".." />
                              <h3 className="table-title">Gas Cylinder Purchase</h3><h4>{moment(localStorage.getItem("m_op_date")).format("DD-MM-YYYY")}</h4>
                            </div>
                            <div className="col-4">
                              <button
                                className="btn btn-primary px-3 mb-md-0 mb-2"
                                onClick={toggle}
                              >
                                Add GAS PRODUCTS
                              </button>
                            </div>
                            <OperationalListFilterBar
                              filters={searchFilters}
                              onChange={handleSearch}
                              onSearch={submitSearchFilters}
                              onClear={clearSearchFilters}
                              searchLabel="Vendor / customer"
                              searchPlaceholder="Vendor, customer, or invoice"
                            />
                          </div>
                          <div className="table-widget" style={{ padding: '10px', backgroundColor: '#f8f9fa' }}>
    <div className="table border" style={{ border: '1px solid #dee2e6', borderRadius: '5px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead style={{ backgroundColor: '#343a40', color: '#ffffff' }}>
                <tr>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Date</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Product Name</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Quantity</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Gst%</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Purchase Price (exc-gst)</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Gst Return</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Mrp</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Transaction Type</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Customer</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Vendor</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Note</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Total</th>
                    <th style={{ padding: '8px', border: '1px solid #dee2e6' }}>Action</th>
                </tr>
            </thead>
            <tbody>
                {list_gas.map((pro, proindex) => (
                    <React.Fragment key={proindex}>
                        {pro.m.map((submeta, submetaindex) => (
                            <tr key={submetaindex}>
                                {submetaindex === 0 && (
                                    <td
                                        rowSpan={pro.m.length}
                                        style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                    >
                                        {moment(pro.op_date).format("DD-MM-YYYY")}
                                    </td>
                                )}
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{submeta.product_name}</td>
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{submeta.quantity}</td>
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{submeta.gst_percentage}</td>
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{submeta.pp_per_piece_exc_gst}</td>
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{submeta.return_gst}</td>
                                <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{Number(submeta.mrp || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>

                                {submetaindex === 0 && (
                                    <>
                                        <td
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            {pro.trans_type === 2 ? (
                                                pro.digital_payment
                                            ) : pro.trans_type === 3 ? (
                                                pro.bank_name
                                            ) : pro.trans_type === 1 ? (
                                                "Credit"
                                            ) : pro.trans_type === 0 ? (
                                                "Cash"
                                            ) : (
                                                pro.digital_payment === null ? "--" : pro.digital_payment
                                            )}
                                        </td>
                                        <td
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            {pro.cust_name === null ? "--" : pro.cust_name}
                                        </td>
                                        <td
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            {pro.name === null ? "--" : pro.name}
                                        </td>
                                        <td
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            {pro.note ? pro.note : null}
                                        </td>
                                        <td
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            {Number(pro.total || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                        </td>
                                        <td
                                            className="py-2"
                                            rowSpan={pro.m.length}
                                            style={{ padding: '8px', border: '1px solid #dee2e6' }}
                                        >
                                            <a
                                                href="#"
                                                className="text-dark me-2"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="View"
                                                onClick={() => viewproduct(pro.id)}
                                                style={{ textDecoration: 'none', color: '#000000' }}
                                            >
                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                            </a>
                                            <a
                                                href="#"
                                                className="text-danger"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                                onClick={() => handleDeleteGas(pro.id)}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                            </a>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    </div>
</div>



                        </div>
                      </div>
                    </div>
                  
                </div>
              </div>
              {/* Uncomment and customize if needed */}
              {/* {path == "/productsconfig/productsconfig" ? "" :
                <div className="text-end mt-4">
                  <button className="btn btn-primary px-3 mb-md-0 mb-2" onClick={''}>Continue</button>
                </div>
              } */}
            </div>
          </div>
        </div>
      </div>
      {/* Modal for adding gas products */}
      {isShowing && (
        <React.Fragment>

        <div class="container pb-3">
  
  
          <div class="row mb-3 justify-content-center">
            <div className="modal-overlay" />
            <div className="modal-wrapper  modal-style" aria-modal aria-hidden tabIndex={-1} role="dialog">
              <div className="modal  modalxxl col-12 ">
                <div class="modal-header mb-3">
                  <h5 class=" text-center" id="staticBackdropLabel">Gas Cylinder Purchase purchase</h5>
                  <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={toggle}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
  
  
                <div >

                  <div class="row mb-3 justify-content-center py-3">
  
                    <div class=" col-md-6 pe-0 ps-4">
                      <div class="row g-3 justify-content-center mb-2">
                        <div class="col-4">
                          <label class="col-form-label">From<sup class="star">*</sup></label>
                        </div>
                        <div class="col-6">
                          <div className="select-container">
                            <select id="" class="form-control " name="fromValue" value={inputValues.fromValue} onChange={handleChange}>
                              <option>Select</option>
                              <option value='0'>Vendor</option>
                              <option value='1'>Customer</option>
                            
                            </select>
                          </div> 
                          <div className="errorMsg">{errors.fromValue}</div>
                        </div>
                        <div class="col-2"></div>
                      </div>
                      {/* 
                       */}

{inputValues.fromValue === '0' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-4">
            <label className="col-form-label">Select Vendor<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="vendor_id" value={inputValues.vendor_id} onChange={handleChange}>
                <option>Select</option>
                {vendor_data.map((data) => (
                  <option key={data[0]} value={data[0]}>{data[1]}</option>
                ))}
              </select>
              
            </div>
            <div className="errorMsg">{errors.vendor_id}</div>
          </div>
          <div className="col-2"></div>
        </div>
      )}
      {inputValues.fromValue === '1' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-4">
            <label className="col-form-label">Select Customer<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="customer_id" value={inputValues.customer_id} onChange={handleChange}>
                <option>Select</option>
                {customer_data.map((data) => (
                  <option key={data[0]} value={data[0]}>{data[1]}</option>
                ))}
              </select>
            </div>
            <div className="errorMsg">{errors.customer_id}</div>
          </div>
          <div className="col-2"></div>
        </div>
      )}
      {inputValues.fromValue === '0' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-4">
            <label className="col-form-label">Select Type<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="type" value={inputValues.type || ""} onChange={handleChange}>
                <option>Select</option>
                <option value='0'>Full Cylinder</option>
                {isNfStockUpVendor && (
                <option value='2'>Empty Cylinder</option>
                )}
                {!isNfStockUpVendor && (
                <option value='1'>Empty to Full Cylinder Exchange</option>
                )}
              </select>
            </div>
            {/* <div className="errorMsg">{errors.vendor_id}</div> */}
          </div>
          <div className="col-2"></div>
        </div>
      )}
       {inputValues.fromValue === '1' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-4">
            <label className="col-form-label">Select Type<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="type" value={inputValues.type}onChange={handleChange}>
                <option>Select</option>
                <option value='2'>Empty Cylinder</option>
                {/* {vendor_data.map((data) => (
                  <option key={data[0]} value={data[0]}>{data[1]}</option>
                ))} */}
              </select>
            </div>
            <div className="errorMsg">{errors.type}</div>
          </div>
          <div className="col-2"></div>
        </div>
      )}
                      {!isNfStockUpVendor && (
                      <div class="row g-3 justify-content-center mb-2">
                        <div class="col-4">
                          <label class="col-form-label">Invoice Number<sup class="star">*</sup></label>
                        </div>
                        <div class="col-6">
                          <input type="text" class="form-control hide-arrow" name="invoice_number" maxLength={50} inputMode="numeric" value={inputValues.invoice_number} onKeyPress={(event) => prevNonNumericalWithDec(event, event.target.value, "invoice")} onChange={handleChange} ></input>
                          <div className="errorMsg">{errors.invoice_number}</div>
  
                        </div>
                        <div class="col-2"></div>
                      </div>
                      )}
                      <div class="row g-3 justify-content-center mb-2">
                        <div class="col-4">
                          <label class="col-form-label">{isNfStockUpVendor ? "Date" : "Invoice Date"}<sup class="star">*</sup></label>
                        </div>
                        <div class="col-6">
                          <input type="date" class="form-control " name="m_op_datem_op_date" id={"m_op_date"} value={inputValues.m_op_date || localStorage.getItem("m_op_date") || ""} min={''} max={''} onChange={handleChange} disabled></input>
                          {/* <div className="errorMsg">{errors.invoice_date}</div> */}
                        </div>
                        <div class="col-2"></div>
                      </div>
                      <>
                      {fieldGroups.map((group, idx) => (
        <div key={idx}>
{console.log(group,"groupgroup")}

{(inputValues.type === '1' || inputValues.type === '0' || inputValues.type === '2') && (
  <div className="row g-3 justify-content-center mb-2">
    <div className="col-4">
      <label className="col-form-label">Product Name<sup className="star">*</sup></label>
    </div>
    <div className="col-6">
      <div className="select-container">
        <select
          className="form-control rackids product"
          name="product_id"
          value={group.product_id || ''}
          onChange={(e) => handleChanges(idx, e)}
        >
          <option>Select</option>
          {productsdropdown.map((data) => (
            <option key={data[0]} value={data[0]}>{data[1]}</option>
          ))}
          {/* Render product options here */}
        </select>
      </div>
      <div className="errorMsg">{errors[`product_${idx}_id`]}</div>
    </div>
    <div className="col-2">
      <button className="btn-add me-2" onClick={handleAdd}>+</button>
      {fieldGroups.length > 1 && (
        <button className="btn-add" onClick={() => handleRemove(idx)}>-</button>
      )}
    </div>
  </div>
)}
 
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">Number of Purchase Quantity<sup className="star">*</sup></label>
            </div>
            <div className="col-6">
              <input
                type="text"
                className="form-control hide-arrow"
                name="quantity"
                value={group.quantity || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
            <div className="errorMsg">{errors[`quantity${idx}_id`]}</div>

            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">Purchase Price/piece inc gst after discount</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="pp_inc_gst_aft_disc"
                value={group.pp_inc_gst_aft_disc || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
            {/* <div className="errorMsg">{errors[`pp_inc_gst_aft_disc${idx}_id`]}</div> */}
            </div>
            <div className="col-2"></div>
          </div>
          {group.product_id ? (
  <div className="row g-3 justify-content-center mb-2">
    <div className="col-4">
      <label className="col-form-label">Do You Want To Change Price<sup className="star">*</sup></label>
    </div>
    <div className="col-6">
      <select
        className="form-control"
        name="price_change"
        value={group.price_change || ''}
        onChange={(e) => handleChanges(idx, e)}
      >
        <option value="">Select</option>
        <option value="0">No</option>
        <option value="1">Yes</option>
      </select>
      <div className="errorMsg">{errors[`price_change${idx}_id`]}</div>
    </div>
    <div className="col-2"></div>
  </div>
) : null}

{group.price_change == '1' && (
  // alert(1),
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-4">
            <label className="col-form-label">
              New Purchase Price<sup className="star">*</sup>
            </label>
          </div>
          <div className="col-6">
            <input
              type="number"
              step="0.01"
              min="0"
              className="form-control"
              name="new_price"
              value={group.new_price || ''}
              onChange={(e) => handleChanges(idx, e)}
            />
            <div className="errorMsg">{errors[`new_price${idx}_id`]}</div>
          </div>
          <div className="col-2"></div>
        </div>
      )}
     {(group.price_change == '1' && inputValues.fromValue == 0 && inputValues.type === '0') ? (
      //  alert(2),
  <div className="row g-3 justify-content-center mb-2">
    <div className="col-6">
      <div className="row">
        <div className="col-6">
          <label className="col-form-label">
            Empty Cylinder Price
          </label>
        </div>
        <div className="col-6">
          <input
            type="text"
            className="form-control form-control-sm"
            name="price_change_empty"
            value={group.price_change_empty || ''}
            onChange={(e) => handleChanges(idx, e)}
          />
          <div className="errorMsg">{errors[`price_change_empty${idx}_id`]}</div>
          <div className="errorMsg">{errors[`price_sum_mismatch${idx}_id`]}</div>
        </div>
      </div>
    </div>
    <div className="col-4">
      <div className="row">
        <div className="col-4">
          <label className="col-form-label">
            Gas Price<sup className="star">*</sup>
          </label>
        </div>
        <div className="col-8">
          <input
            type="text"
            className="form-control form-control-sm"
            name="price_change_gas"
            value={group.price_change_gas || ''}
            onChange={(e) => handleChanges(idx, e)}
          />
          <div className="errorMsg">{errors[`price_change_gas${idx}_id`]}</div>
        </div>
      </div>
    </div>
  </div>
) : 

<div hidden className="row g-3 justify-content-center mb-2">

<div className="col-6">
  <div className="row">
    <div hidden className="col-6">
      <label className="col-form-label">
        Empty Cylinder Price
      </label>
    </div>
    <div className="col-6">
      <input
      hidden
        type="text"
        className="form-control form-control-sm"
        name="price_change_empty"
        value={group.price_change_empty || ''}
        onChange={(e) => handleChanges(idx, e)}
      />
    
    </div>
  </div>
</div>
<div hidden className="col-4">
  <div className="row">
    <div hidden className="col-4">
      <label className="col-form-label">
        Gas Price<sup className="star">*</sup>
      </label>
    </div>
    <div className="col-8">
      <input
      hidden
        type="text"
        className="form-control form-control-sm"
        name="price_change_gas"
        value={group.price_change_gas || ''}
        onChange={(e) => handleChanges(idx, e)}
      />
      <div className="errorMsg">{errors[`price_change_gas${idx}_id`]}</div>
    </div>
  </div>
</div>
</div>}




          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">Total Purchase Price inc gst aft disc</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="total_pp_inc_gst_aft_disc"
                value={group.total_pp_inc_gst_aft_disc || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
            </div>
            <div className="col-2"></div>
          </div>
          {/* Add other fields in a similar way */}
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">GST%<sup className="star">*</sup></label>
            </div>
            <div className="col-6">
              <input
                type="text"
                className="form-control hide-arrow"
                name="gst"
                value={group.gst || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
            <div className="errorMsg">{errors[`gst${idx}_id`]}</div>
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">Purchase price/piece exc gst</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="pp_per_piece_exc_gst"
                value={group.pp_per_piece_exc_gst || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
              {/* Error message for GST */}
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">gstamount</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="gstamount"
                value={group.gstamount || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
              {/* Error message for GST */}
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">cgst</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="cgst"
                value={group.cgst || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
              {/* Error message for GST */}
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">sgst</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="sgst"
                value={group.sgst || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
              {/* Error message for GST */}
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">Mrp/piece<sup className="star">*</sup></label>
            </div>
            <div className="col-6">
              <input
                type="text"
                className="form-control hide-arrow"
                name="mrp"
                value={group.mrp || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
            <div className="errorMsg">{errors[`mrp${idx}_id`]}</div>
            </div>
            <div className="col-2"></div>
          </div>
          <div className="row g-3 justify-content-center mb-2">
            <div className="col-4">
              <label className="col-form-label">GST return</label>
            </div>
            <div className="col-6">
              <input
              readOnly
                type="text"
                className="form-control hide-arrow"
                name="gst_return"
                value={group.gst_return || ''}
                onChange={(e) => handleChanges(idx, e)}
              />
              {/* Error message for GST */}
            </div>
            <div className="col-2"></div>
          </div>
        </div>
        
      ))}
  </>
                        
                    </div>
                    <div class="col-md-6">
                      <div class="row g-3 justify-content-center mb-2">
                        <div class="col-5   ">
                          <label class="col-form-label ">Net Total</label>
                        </div>
                        <div class="col-6">
                          <input readOnly type="text" class="form-control hide-arrow" onKeyPress={''} name="total" id={"net_amount"}  value={total} onChange={handleChange}></input>
                        </div>
  
                      </div>
                      <div className="row g-3 justify-content-center mb-2">
  <div className="col-5">
    <label className="col-form-label">
      Transaction Type<sup className="star">*</sup>
    </label>
  </div>
  <div className="col-6">
    <div className="select-container">
      <select
        id="transaction-type"
        className="form-control"
        name="purchase_type"
        value={inputValues.purchase_type}
        onChange={handleChange}
      >
        <option>Select</option>
        <option value="0">Cash</option>
        <option value="1">Credit</option>
        <option value="2">Digital Payment</option>
        <option value="3">Bank</option>
      </select>
      <div className="errorMsg">{errors.purchase_type}</div>
    </div>
  </div>
</div>

                      {inputValues.purchase_type === '2' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-5">
            <label className="col-form-label">Select Digital Type<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="Digital_Type" onChange={handleChange}>
                <option>Select</option>
                {dropdownDatas.map(item => (
                <option key={item.value} value={item.value}>
                    {item.label}
                </option>
            ))}
              </select>
            </div>
            <div className="errorMsg">{errors.Digital_Type}</div>
          </div>
          <div className="col-2"></div>
        </div>
        )}
       {inputValues.purchase_type === '3' && (
        <div className="row g-3 justify-content-center mb-2">
          <div className="col-5">
            <label className="col-form-label">Select Bank<sup className="star">*</sup></label>
          </div>
          <div className="col-6">
            <div className="select-container">
              <select className="form-control" name="bank" onChange={handleChange}>
                <option>Select</option>
                {banks.map(([id, method_name]) => (
          <option key={id} value={id}>
            {method_name}
          </option>
        ))}
              </select>
            </div>
            <div className="errorMsg">{errors.bank}</div>
          </div>
          <div className="col-2"></div>
        </div>
      )}
    
                      <div class="row g-3 justify-content-center mb-2">
                        <div class="col-5">
                          <label class="col-form-label">Description</label>
                        </div>
                        <div class="col-6">
                          <textarea type="text" class="form-control " name="note" value={inputValues.note} onChange={handleChange}></textarea>
                        </div>
  
                      </div>
                      {/* <div class="row g-3 justify-content-center mb-2">
                        <div class="col-5">
                          <label class="col-form-label">Invoice Amount</label>
                        </div>
                        <div class="col-6">
                          <input type=" number" class="form-control" name="invoice_amount" id={"invoice_amount"} value={inputValues.invoice_amount}  onChange={handleChange}></input>
                        </div>
  
                      </div>
                   */}
  
                    </div>
                    <div class="modal-footer text-center">
  
                      <a href="#" class="btn btn-danger w-auto" onClick={toggle}>Cancel</a>
                       <a href="#" class="btn btn-primary  w-auto " onClick={handleSubmit}>Save&Approve</a> 
                    </div>
                  </div>
                  <div className="text-end">
                    {/* <Link to="/NonFuel-product-Selling-Price-Change"> <a href="/NonFuel-product-Selling-Price-Change" class=" text-danger text-end mx-3">Changing Selling Price</a></Link> */}
                    </div>
  
                </div>
              </div>
            </div>
          </div>
        </div>
  
  
  
      </React.Fragment>
      )}

{console.log(list_view,"vvvvvvvvvvvvvvvvvvvvvv")}

       Modal for adding gas products
       {isviewShowing && (
        <React.Fragment>

{/* {console.log(tank_data)} */}
    <div className="modal-overlay" />
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)' }}>
  <div className="modal modal-dialog-xl" style={{ maxWidth: '90vw', width: '90vw', maxHeight: '80vh', height: 'auto', overflow: 'auto' }}>
    <div className="modal-header mb-3">
      <h5 className="text-center" id="staticBackdropLabel">Gas Purchase Report</h5>
      <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={viewproductclose}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div className="modal-body" style={{ overflow: 'auto' }}>
      <div className="table-widget">
        <div className="table border">
          <div style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '100%' }}>
            {list_view.map((pro, proindex) => (
              <thead key={`head-${proindex}`}>
                <tr>
                  <td>Date</td>
                  <th>{purchasePartyColumnLabel(pro)}</th>
                  <th>Type</th>
                  <th>Note</th>
                  <th>Product Name</th>
                  <th>Quantity</th>
                  <th>Purchase Price(inc-gst)</th>
                  <th>Gst%</th>
                  <th>Purchase Price(exc-gst)</th>
                  <th>Gst Return</th>
                  <th>Mrp</th>
                  <th>Transaction Type</th>
                  <th>Total</th>
                </tr>
              </thead>
            ))}
              <tbody>
                {list_view.map((pro, proindex) => (
                 <React.Fragment key={proindex}>
                 {pro.m.map((submeta, submetaindex) => {
                   return (
                     <tr key={submetaindex}>
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {moment(pro.op_date).format("DD-MM-YYYY")}
                         </td>
                       )}
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {purchasePartyName(pro)}
                         </td>
                       )}
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {purchaseKindLabel(pro.type)}
                         </td>
                       )}
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {pro.note ? pro.note : null}
                         </td>
                       )}
                       <td>{submeta.product_name}</td>
                       <td>{submeta.quantity}</td>
                       <td>{submeta.pp_inc_gstanddisc}</td>
                       <td>{submeta.gst_percentage}</td>
                       <td>{submeta.pp_per_piece_exc_gst}</td>
                       <td>{submeta.return_gst}</td>
                       <td>{submeta.mrp}</td>
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {pro.trans_type === 2 ? (
                             pro.digital_payment
                           ) : pro.trans_type === 3 ? (
                             pro.bank_name
                           ) : pro.trans_type === 1 ? (
                             "Credit"
                           ) : pro.trans_type === 0 ? (
                             "Cash"
                           ) : (
                             pro.digital_payment === null ? "--" : pro.digital_payment
                           )}
                         </td>
                       )}
                       {submetaindex === 0 && (
                         <td rowSpan={pro.m.length}>
                           {pro.total ? pro.total : null}
                         </td>
                       )}
                     </tr>
                   );
                 })}
               </React.Fragment>
               
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





  </React.Fragment>
      )}
    </>
  );
};

export default GasCylinderPurchaseConfig;
